import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-dark-900">
      <div className="text-center">
        <div className="mb-8 text-8xl font-bold text-dark-700">404</div>
        <h1 className="mb-4 text-2xl font-bold text-dark-100">Page Not Found</h1>
        <p className="mb-8 text-dark-400">
          The page you're looking for doesn't exist or you don't have permission to access it.
        </p>
        <Link to="/dashboard" className="btn btn-primary">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}
